<template>
    <div>
        <img src="/images/star_gray.png"
             class="pointer"
             alt=""
             @click="item.clickEvent.func($event, item, item.clickEvent.params)" v-if="item.values === false || item.values === 0"
        />
        <img src="/images/star_blue.png"
             alt=""
             @click="item.clickEvent.func($event, item, item.clickEvent.params)" v-else class="pointer"
        />
    </div>
</template>
<script>
    export default {
        props: ['item'],
    }
</script>